import React from "react";
import "../App.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Moment from 'moment';

class MMPLPendingTaskMDocSDoc extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      check :0,
    };
   setInterval(() => {
     this.setState({check : 1})
   }, 500) 
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  updatePopover(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>Update</label>
        </Popover.Content>
      </Popover>
    );
  }


  showCollectMDocSDocPanel = (item) => {
    const { history, dispatch } = this.props;
    // dispatch({ type: "MMPLSidePanCollectDocs", data: true });
    dispatch({ type: "CollectMdocSdocDetails", data: item });
    // history.push(`/Home/MMPLDashboard/MDocSDoc/${id}`);
    // history.push(`/Home/MDCollect/${item.poLineItemId}`);
    history.push(`/Home/POValidationMDSDoc/${item.shipId}/${item.purchaseOrderId}`);
    window.scrollTo(0, 0);
  };

  showPODetailPanel = (shipId, poId) => {
    const { history, dispatch } = this.props;
    dispatch({ type: "EditPOView", data: false });
    history.push(`/Home/POView/${shipId}/${poId}`);
    window.scrollTo(0, 0);
  };

  render() {
    const { pageSize, totalRecords } = this.props;
    return (
      <div className="pb-4">
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="p-0">
              <div className="row">
                <div className="col-sm-12">
                  {this.renderCardPendingData()}
                </div>
              </div>
            </div>
          </div>
        </div>

        {totalRecords !== 0 ? (
          <Paginator
            first={this.state.first}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}>
          </Paginator>
        ) : (
            <div className="card" style={{ overflow: "hidden", position: "relative" }}>
              <div class="container">
                <h6 className="resource-list-title no-item-card">
                  No Tasks
              </h6>
              </div>
            </div>
          )}
      </div>
    );
  }

  onPaginatorChange(event) {
    const { setUpdatedState } = this.props;
    this.setState({ first: event.first });
    setUpdatedState(event.page + 1);
  }


  renderCardPendingData = () => {
    const { arraylist, MMPLSidePanCollectDocs, sendMail, HoldMail } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
       return (
          <div className="card" style={{ overflow: "hidden", position: "relative", marginBottom: '5px' }}>
            {item.isOnHold ? (
              <div className="arrow-left-red"></div>
            ) : (
                <div className="arrow-left-green"></div>
              )}
            <div className="px-3 py-2">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className={MMPLSidePanCollectDocs ? "col-sm-9 col-md-9 col-m-auto" : "col-8 col-lg-9 col-m-auto col-md-9 col-sm-9 col-xl-10"}>
                    <div className="row">
                      <div className="col-sm-4 col-md-3 m-auto">
                        <h6 className="resource-list-title mb-0" style={{ cursor: "pointer" }}
                          onClick={() => this.showPODetailPanel(item.shipId, item.purchaseOrderId)}>{item ? item.poNo : ""}
                        </h6>
                      </div>
                      <div className="col-sm-4 col-md-3 m-auto">
                        <span>
                          <strong>PO Date : </strong>
                          <span className="italicFont">{item ? Moment(new Date(Date.parse(item.poDate))).format('DD MMM YYYY') : ""}</span>
                        </span>
                      </div>
                      <div className="col-sm-4 col-md-3 m-auto">
                        <span>
                          <strong>Quantity : </strong>
                          <span className="italicFont">{item ? item.quantity : ""}</span>
                        </span>
                      </div>
                      <div className="col-sm-4 col-md-3 m-auto">
                        <span>
                          <strong>Ship Name : </strong>
                          <span className="italicFont ">{item ? item.vesselName : ""}</span>
                        </span>
                      </div>
                      <div className="col-sm-4 col-md-3 mt-1">
                        <span>
                          <strong>First Mail Sent On : </strong>
                          <span className="italicFont ">{item?.firstReminderMailSentOn ? Moment(item?.firstReminderMailSentOn,'DD-MM-YYYY').format('DD MMM YYYY') : ""}</span>
                        </span>
                      </div>
                      <div className="col-sm-4 col-md-3 mt-1">
                        <span>
                          <strong>Last Mail Sent On : </strong>
                          <span className="italicFont ">{item?.reminderLastSentOn ? Moment(item?.reminderLastSentOn,'DD-MM-YYYY').format('DD MMM YYYY') : ""}</span>
                        </span>
                      </div>
                      <div className="col-sm-4 col-md-3 mt-1">
                        <span>
                          <strong>Is Hold : </strong>
                        <strong className={item.isOnHold ? "italicFont text-red" : "italicFont text-green"}>{item && item.isOnHold == true ? "Yes" : "No"}</strong>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className={MMPLSidePanCollectDocs ? " col-sm-3 col-md-3 col-m-auto" : "col-4 col-m-auto col-md-3 col-sm-3 col-xl-2 col-lg-3"}>
                    <div className="row">
                      <div className="col-12 col-lg-9 col-md-12 col-md-9 col-sm-12 col-sm-9 col-xl-9 px-0">
                      <button class="btn btn-secondary btn-xs btn-conf-edit" data-confirmation="cancel" style={{ width: "160px" }} id='EditAll' onClick={() => sendMail(item)}>
                          <i class="glyphicon glyphicon-remove"></i> Send Reminder Email
                        </button>
                        <button class="btn btn-secondary btn-xs btn-conf-edit mt-2" data-confirmation="cancel" style={{ width: "160px" }} id='EditAll' onClick={() => HoldMail(item)}>
                          <i class="glyphicon glyphicon-remove"></i> Hold Mail / Release
                        </button>
                      </div>
                     
                      <div className={window.innerWidth > 992 ? "col-12 col-lg-3 col-md-12 col-sm-12 col-xl-3 my-auto " : "col-12 col-lg-3 col-md-12 col-sm-12 col-xl-3 my-auto pl-5 ml-3"}>
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={this.updatePopover()} >
                          <i className="fa fa-edit click mt-2" aria-hidden="true" style={{ color: " #1E3A8A", fontSize: '30px' }} onClick={() => this.showCollectMDocSDocPanel(item)}>
                          </i>
                        </OverlayTrigger>
                      </div>
                    
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }) : null;
  };

}

function mapStateToProps(state) {
  return {
    MMPLSidePanCollectDocs: state.MMPLDashboardReducer.MMPLSidePanCollectDocs,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MMPLPendingTaskMDocSDoc)
);
